module.exports = __webpack_public_path__ + "img/scene1-1.ea90bcb5.jpg";